<div class="multi-line-input-wrapper">
  @if (properties.text) {
    <div [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']" [style]="textStyle()">
      {{ properties.text }}
    </div>
  }
  <div class="input-container">
    @if (properties.inputCaptionLeft) {
      <span>{{ properties.inputCaptionLeft }}</span>
    }
    <textarea
      [formControl]="formControl!"
      [id]="htmlId()"
      [name]="htmlId()"
      [placeholder]="''"
      [rows]="DEFAULT_ROWS"
      [cols]="DEFAULT_COLUMNS"
      [style]="inputStyle()"
      (change)="onChange($event)">
    </textarea>
    @if (properties.inputCaptionRight) {
      <span>{{ properties.inputCaptionRight }}</span>
    }
  </div>
</div>
